import { render, staticRenderFns } from "./Crew.vue?vue&type=template&id=93695c3e&scoped=true&"
import script from "./Crew.vue?vue&type=script&lang=js&"
export * from "./Crew.vue?vue&type=script&lang=js&"
import style0 from "./Crew.vue?vue&type=style&index=0&id=93695c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93695c3e",
  null
  
)

export default component.exports